import {CmsReactComponent} from 'components/cms/CmsReactComponent';
import {EntryOptions, PropertyDefinition, PropertyMappingType,} from "app/library/layout-builder";
import {MobileInstrumentsListProps} from "./types";
import {MetaTypeEnum} from "app/shared";

export class MobileInstrumentsListDefinitions extends CmsReactComponent<MobileInstrumentsListProps> {
    static defaultProps = {};

    static schemaName = "mobile-instruments-list";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "title",
            mapping: {
                type: PropertyMappingType.String,
            },
            default: "",
            text: "Başlık",
        },
        {
            name: "secondTitle",
            mapping: {
                type: PropertyMappingType.String,
            },
            default: "",
            text: "Alt Başlık",
        },
        {
            name: "backAnchor",
            mapping: {
                type: PropertyMappingType.String,
            },
            default: "",
            text: "Geriye Dönmek İçin Kullanılan Anchor",
        },
        {
            name: "data",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: [
                    {
                        name: "turkishInformationTitle",
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                        default: "",
                        text: "Türkçe Bilgi Başlığı",
                    },
                    {
                        name: "englishInformationTitle",
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                        default: "",
                        text: "İngilizce Bilgi Başlık",
                    },
                    {
                        name: "anchor",
                        mapping: {
                            type: PropertyMappingType.LinkWizard,
                        },
                        description: "Liste Url ",
                        default: null,
                    }
                ]
            },
            group: {
                key: "data",
                title: "Kart Verileri",
                withObject: false,
            },
            default: "",
            text: "List"
        },
    ];

    static options: EntryOptions = {
        meta: {
            use: true,
            allowedTypes: [
                MetaTypeEnum.Text,
                MetaTypeEnum.TextArea,
                MetaTypeEnum.SingleImage,
                MetaTypeEnum.Editor,
            ],
        },
    };
}
